import http from "../plugins/axios";
import { AxiosError } from "axios";
import { ArticleModel } from "./contest";

export interface ProblemLanguage {
  name: string;
  compiler: string;
  args: string;
}

export interface ProblemSubmitFile {
  name: string;
  desc: string;
  autoJudge: boolean;
}

export interface ProblemModel {
  id: number;
  title: string;
  judgeType: string;
  languages: ProblemLanguage[];
  description: ArticleModel | undefined;
  datainfo: ArticleModel | undefined;
  judgeinfo: ArticleModel | undefined;
  articles: ArticleModel[];
  submitFile: ProblemSubmitFile[];
}

export interface DatasetModel {
  id: number;
  name: string;
  desc: string;
  fileKey: string;
  size: string;
  downloadTime: number;
}

export function fetchOneProblem(
  // token: string,
  contestId: number,
  trackId: number,
  stageId: number,
  problemId: number
): Promise<ProblemModel> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/problem/${problemId}`,
        {
          // headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data as ProblemModel);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchProblems(
  // token: string,
  contestId: number,
  trackId: number,
  stageId: number
): Promise<ProblemModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(
        `/api/competition/${contestId}/track/${trackId}/stage/${stageId}/problem`,
        {
          // headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.data as ProblemModel[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function fetchDatasets(
  // token: string,
): Promise<DatasetModel[]> {
  return new Promise((resolve, reject) => {
    http
      .get(`/api/dataset`, {
        // headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        return resolve(response.data.data as DatasetModel[]);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}

export function getDatasetFileUrl(
  // token: string,
  id: number,
  key: string
): Promise<string> {
  return new Promise((resolve, reject) => {
    //console.log(id,key,"123");
    http
      .post(
        `/api/dataset/fileurl`,
        {
          id: id,
          key: key,
        },
        {
          // headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        return resolve(response.data.url);
      })
      .catch((error: AxiosError) => {
        if (error.response) {
          const status = error.response.status;
          if (status === 401) return reject("token-invalid");
          else if (status === 404) return reject("unknown-page");
          else if (status === 400) return reject("400-turn-to-admin");
          else if (status === 500) return reject("500-turn-to-admin");
          else return reject("unknown-turn-to-admin");
        } else return reject("unknown-turn-to-admin");
      });
  });
}
